import Reveal from "./Reveal";
import { CONTACT } from "@/data/content";

export default function Pricing() {
    return (
        <section
            id="preise"
            data-testid="pricing-section"
            className="section-y relative bg-muted/40"
        >
            <div className="container-em">
                <div className="grid lg:grid-cols-12 gap-10 items-center">
                    <div className="lg:col-span-6">
                        <Reveal>
                            <span className="font-accent text-xs uppercase tracking-[0.3em] text-primary">
                                Preise
                            </span>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2
                                data-testid="pricing-title"
                                className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight text-balance"
                            >
                                Faire Preise.
                                <br />
                                <em className="not-italic text-primary">
                                    Persönliches Angebot.
                                </em>
                            </h2>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <p className="mt-6 text-foreground/75 text-lg leading-relaxed max-w-xl">
                                Bei längeren Aufenthalten bieten wir attraktive
                                Preisvorteile. Ideal für Kurz- und
                                Langzeitaufenthalte – jedes Angebot machen wir
                                Dir individuell.
                            </p>
                        </Reveal>
                    </div>

                    <div className="lg:col-span-6">
                        <Reveal>
                            <div
                                data-testid="pricing-card"
                                className="relative rounded-3xl bg-card border border-border/60 p-10 md:p-12 overflow-hidden"
                            >
                                <div
                                    aria-hidden
                                    className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-primary/10"
                                />
                                <div
                                    aria-hidden
                                    className="absolute -bottom-20 -left-20 w-52 h-52 rounded-full bg-secondary/40"
                                />
                                <div className="relative">
                                    <p className="font-accent text-xs uppercase tracking-[0.3em] text-foreground/60">
                                        Übernachtung
                                    </p>
                                    <div className="mt-4 flex items-baseline gap-2">
                                        <span className="font-display text-2xl text-foreground/70">
                                            ab
                                        </span>
                                        <span className="font-display text-7xl md:text-8xl leading-none text-foreground">
                                            110
                                        </span>
                                        <span className="font-display text-4xl md:text-5xl text-foreground/80">
                                            €
                                        </span>
                                        <span className="ml-2 text-foreground/60 text-base">
                                            / Nacht
                                        </span>
                                    </div>
                                    <p className="mt-6 text-foreground/70 leading-relaxed">
                                        Der finale Preis richtet sich nach
                                        Aufenthaltsdauer und Saison. Ab einer
                                        Woche gewähren wir gerne Rabatte.
                                    </p>
                                    <a
                                        href="#anfrage"
                                        data-testid="pricing-inquiry-button"
                                        className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-7 py-4 text-base font-medium hover:bg-primary/90 transition-all duration-300 hover:-translate-y-0.5"
                                    >
                                        Individuelles Angebot anfragen
                                    </a>
                                </div>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
